import { Component, Input } from '@angular/core';
import { ColorBgIconComponent } from '@forgerock/backstage-ui-components';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { EverythingSearchResult } from '../../../model/everything-search-result';
import { SearchResultLinkDirective } from '../../../search-result-link.directive';
import { EllipsisComponent } from '../../../utils/ellipsis/ellipsis.component';
import { SearchResultCardComponent } from '../../search-result-card/search-result-card.component';

@Component({
  selector: 'app-search-result-path',
  templateUrl: './search-result-path.component.html',
  styleUrls: [ './search-result-path.component.scss' ],
  imports: [ SearchResultCardComponent, SearchResultLinkDirective, ColorBgIconComponent, NgbTooltip, EllipsisComponent ]
})
export class SearchResultPathComponent {
  @Input() result: EverythingSearchResult;
}
